module.exports = __webpack_public_path__ + "static/img/68081H_R_1_20171016_LC.ad4daf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081H_R_1_20171016_LC.png
// module id = fwsy
// module chunks = 0